import { bound } from "@frui.ts/helpers";
import { ConductorOneChildActive, Router } from "@frui.ts/screens";
import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { computed } from "mobx";
import { Modules } from "../../../config";
import LocalizationService from "services/localizationService";
import SecurityService from "services/securityService";
import type { IModuleViewModel } from "../../types";
import DistributorManagementViewModel from "./distributorManagement/distributorManagementViewModel";
import DistributorPaymentRequestReports from "./distributorPaymentRequestReports/distributorPaymentRequestReports";
import CommissionsForInvoiceViewModel from "./commissionsForInvoice/commissionsForInvoiceViewModel";
import DistributorChargesOrderDifferencesViewModel from "./distributorChargesOrderDifferences/distributorChargesOrderDifferencesViewModel";
import CreditExposuresViewModel from "./creditExposures/creditExposuresViewModel";
import DistributorRefundsViewModel from "./distributorRefunds/distributorRefundsViewModel";

const navigationName = "distributors";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [
    DistributorManagementViewModel,
    DistributorPaymentRequestReports,
    DistributorChargesOrderDifferencesViewModel,
    DistributorRefundsViewModel,
  ],
})
export default class DistributorsViewModel extends ConductorOneChildActive<ScreenBase> implements IModuleViewModel {
  showChildrenSubmenu = true;

  constructor(
    private localizationService: LocalizationService,
    private distributorManagementViewModel: DistributorManagementViewModel,
    private distributorPaymentRequestReports: DistributorPaymentRequestReports,
    private distributorChargesOrderDifferences: DistributorChargesOrderDifferencesViewModel,
    private distributorRefunds: DistributorRefundsViewModel,
    private commissionForInvoiceViewModel: CommissionsForInvoiceViewModel,
    private creditExposuresViewModel: CreditExposuresViewModel,
    private securityService: SecurityService
  ) {
    super();
    this.navigationName = navigationName;

    if (this.securityService.allowToEntity("distributor")) {
      this.children.push(this.distributorManagementViewModel);
    }

    if (this.securityService.allowTo("distributors.reports")) {
      this.children.push(this.distributorPaymentRequestReports);
      if (this.securityService.allowTo("distributors.reports", "write")) {
        this.children.push(this.distributorChargesOrderDifferences);
      }
      this.children.push(this.commissionForInvoiceViewModel);
    }

    if (this.securityService.allowToEntity("distributor")) {
      this.children.push(this.creditExposuresViewModel);
    }

    if (
      this.securityService.allowTo("finance.commandoperating") ||
      this.securityService.allowTo("finance.chiefaccounting") ||
      this.securityService.allowTo("distributors")
    ) {
      this.children.push(this.distributorRefunds);
    }
  }

  @computed
  get name() {
    return this.translate("name");
  }

  protected onInitialize(): Promise<any> | void {
    if (!this.activeChild) {
      this.tryActivateChild(this.children[0]);
    }

    return super.onInitialize();
  }

  @bound
  onBackClick() {
    this.requestClose();
  }

  closeChild(child: ScreenBase) {
    return false;
  }

  translate(code: string) {
    return this.localizationService.translateModule(Modules.timeCharges, `distributors.${code}`);
  }
}
